import { render } from "./CartItem.vue?vue&type=template&id=2646712e&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=2646712e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2646712e"]])

export default __exports__